import angular from 'angular';

import rwCard from 'utils/rw-card/rw-card-module';
import gameImagesRouting from './game-images-routing-module';
import CmsGameImagesComponent from './game-images-component';
import GamesTabComponent from './components/games-tab/games-tab-component';
import GameCardComponent from './components/game-card/game-card-component';
import GameSelectorComponent from './components/games-selector/games-selector-component';


export default angular
  .module('game-images', [
    rwCard.name,
    gameImagesRouting.name,
  ])
  .component('cmsGameImages', new CmsGameImagesComponent())
  .component('gamesTab', new GamesTabComponent())
  .component('gameCard', new GameCardComponent())
  .component('gameSelector', new GameSelectorComponent());



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/game-images/game-images-module.js